import React from 'react';

import { Alert } from '@gitbook/spine-react';
import '../../OpenAPI/react-openapi.css';
import './scalar.css';

import { ErrorBoundary } from '@gitbook/util-debug';

import { BlockLoadingFallback, BlockWrapper, type BlockWrapperProps } from '../common';
import { EditorSectionIDsContext } from '../contexts';

export type OpenAPIBlockWrapperProps = BlockWrapperProps;

/**
 * Wrapper of an OpenAPI block.
 */
export function OpenAPIBlockWrapper(props: OpenAPIBlockWrapperProps): React.ReactElement {
    const { node, children } = props;

    const { sections: sectionIDs } = React.useContext(EditorSectionIDsContext);

    const id = sectionIDs.get(node.key);

    const innerContent = (
        <div id={id} className="block-openapi relative">
            <ErrorBoundary
                fallback={<Alert kind="danger" details="Error while rendering OpenAPI operation" />}
            >
                <React.Suspense fallback={<BlockLoadingFallback />}>{children}</React.Suspense>
            </ErrorBoundary>
        </div>
    );

    return <BlockWrapper {...props}>{innerContent}</BlockWrapper>;
}
